import { ElementRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
var ActionsDropdownComponent = /** @class */ (function () {
    function ActionsDropdownComponent(elementRef, cdr) {
        this.elementRef = elementRef;
        this.cdr = cdr;
        this.label = 'Acciones';
        this.items = [];
        this._open = false;
    }
    ActionsDropdownComponent.prototype.toggle = function () {
        if (this._open) {
            this.close();
        }
        else {
            this.open();
        }
    };
    ActionsDropdownComponent.prototype.select = function (item) {
        this.close();
        item.action();
    };
    ActionsDropdownComponent.prototype.ngOnDestroy = function () {
        if (ActionsDropdownComponent.openInstance === this) {
            ActionsDropdownComponent.openInstance = null;
        }
    };
    ActionsDropdownComponent.prototype.open = function () {
        var previous = ActionsDropdownComponent.openInstance;
        if (previous && previous !== this) {
            previous.close();
        }
        this._open = true;
        ActionsDropdownComponent.openInstance = this;
    };
    ActionsDropdownComponent.prototype.close = function () {
        this._open = false;
        if (ActionsDropdownComponent.openInstance === this) {
            ActionsDropdownComponent.openInstance = null;
        }
        // Por si la instancia cerrada cuelga de un padre OnPush.
        this.cdr.markForCheck();
    };
    Object.defineProperty(ActionsDropdownComponent.prototype, "visibleItems", {
        get: function () {
            return this.items.filter(function (item) { return item.visible !== false; });
        },
        enumerable: true,
        configurable: true
    });
    ActionsDropdownComponent.prototype.trackByLabel = function (_index, item) {
        return item.label;
    };
    ActionsDropdownComponent.prototype.onDocumentClick = function (event) {
        if (this._open && !this.elementRef.nativeElement.contains(event.target)) {
            this.close();
        }
    };
    /**
     * Instancia con el menú abierto actualmente (compartida entre todas las instancias).
     * El trigger hace stopPropagation, por lo que el listener de document:click de las
     * demás instancias no llega a ejecutarse; con esta referencia, al abrir un menú se
     * cierra explícitamente el que estuviera abierto.
     */
    ActionsDropdownComponent.openInstance = null;
    return ActionsDropdownComponent;
}());
export { ActionsDropdownComponent };
